export { Tabs, TabsList, TabsContent } from "ics-ui-kit/components/tabs";
export { TabsTrigger } from "./TabsTrigger";
